import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, catchError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from 'src/app/auth/auth.service';
import { SnackbarService } from 'src/app/shared/snackbar/snackbar.service';

export interface StockAlertResponse {
  productAlerts: ProductAlert[];
}

export interface ProductAlert {
  productId: number;
  productCode: string;
  productEAN: string;
  productName: string;
  hasAlertsTriggered: boolean;
  storeAlerts: StoreAlert[];
}

export interface StoreAlert {
  storeId: number;
  storeName: string;
  currentStock: number;
  triggersLowStockAlert: boolean;
  triggersZeroStockAlert: boolean;
  triggersLowRotationAlert: boolean;
  triggersExpirationAlert: boolean;
  minimumStockThreshold?: number;
  lastMovementDate?: string;
  oldestLotExpirationDate?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StockAlertsService {
  private readonly baseUrl = environment.cafler_backoffice_back_url;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private snackbarService: SnackbarService
  ) {}

  checkProductAlerts(productIds: number[]): Observable<StockAlertResponse> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        if (!token) {
          throw new Error('No token available');
        }

        return this.http.post<StockAlertResponse>(`${this.baseUrl}/StockAlerts/check-alerts`, {
          productIds
        }, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
      }),
      catchError((error) => {
        this.snackbarService.showError('Error al cargar las alertas de stock');
        throw error;
      })
    );
  }
}
